import React, {useCallback, useState} from 'react';
import {useSelector} from 'react-redux';

import Button from '@pb/kit-component-button';
import {Dialog} from '@pb/kit-component-dialog-v2';

import {crmIntegrationSelector} from '../../setup/services/selectors';
import {contractsDataSelector, getPricingBusy} from '../services/selectors';

import {AddContractModal} from './add-contract-modal';

type Props = {
    onCreateContract: (number: string) => void,
    canEdit?: boolean,
};

export const AddContractDialog = ({onCreateContract: onCreateContractCb, canEdit}: Props) => {
    const [shown, setShown] = useState(false);
    const pricingBusy = useSelector(getPricingBusy);
    const contractsData = useSelector(contractsDataSelector);
    const crmIntegration = useSelector(crmIntegrationSelector);
    const contractsLength = contractsData?.activeContracts?.length ?? 0;
    const disabled = crmIntegration && contractsLength > 0;

    const onCreate = useCallback((number: string) => {
        onCreateContractCb(number);
        setShown(false);
    }, [onCreateContractCb]);

    const onModalOpen = useCallback(() => {
        setShown(true);
    }, []);

    const onModalClose = useCallback(() => {
        if (!pricingBusy) {
            setShown(false);
        }
    }, [pricingBusy]);

    return (
        <>
            <Dialog
                shown={shown}
                setShown={value => {
                    if (!value) {
                        onModalClose();
                    }
                }}>
                <AddContractModal onClose={onModalClose} onCreateContract={onCreate}/>
            </Dialog>
            <Button variant="Type.PRIMARY" onClick={onModalOpen} disabled={!canEdit || disabled}>Add New Contract</Button>
        </>
    );
};
